<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Popover, IconButton, Text } from '@Shelly/shelly-design-system';

	// Helper function to format numbers with comma as decimal separator
	const formatNumber = (value: number, decimals: number = 2): string => {
		return value.toFixed(decimals).replace('.', ',');
	};

	export let totalCosts: number;
	export let currency: string = '€';
	export let totalUsage: number = 2500;
	export let variant: 'light' | 'dark' = 'light';
	export let layout: 'normal' | 'condensed' = 'normal';

	let showTotalCostsPopover = false;
</script>

<div
	class="total-costs-display"
	class:variant-light={variant === 'light'}
	class:variant-dark={variant === 'dark'}
	class:layout-condensed={layout === 'condensed'}
>
	<span class="total-costs">{formatNumber(totalCosts)} {currency}</span>
	<Popover
		hideCloseBtn={true}
		show={showTotalCostsPopover}
		placement="top"
		type="hover"
		on:close={() => (showTotalCostsPopover = false)}
	>
		<IconButton
			icon="fa-solid fa-circle-info"
			variant="help"
			class="total-costs-info-btn"
			on:click={() => {
				showTotalCostsPopover = !showTotalCostsPopover;
			}}
			aria-label={$format('energy_price_total_costs_info', {
				default: 'Informationen zur Gesamtkostenberechnung',
				locale: 'de',
			})}
			size="s"
		/>
		<svelte:fragment slot="customContent">
			<Text styleType="body-small">
				{$format('energy_price_total_costs_info_text', {
					default:
						'Die jährlichen Gesamtkosten werden basierend auf Ihrem geschätzten jährlichen Stromverbrauch von {totalUsage} kWh berechnet. Sie umfassen den Grundpreis (feste jährliche Gebühr) plus die variablen Kosten (Preis pro kWh × Verbrauch). Dies gibt Ihnen eine Schätzung Ihrer jährlichen Gesamtstromkosten für diesen Tarif.',
					values: {
						totalUsage: totalUsage.toString(),
					},
					locale: 'de',
				})}
			</Text>
		</svelte:fragment>
	</Popover>
</div>

<style>
	.total-costs-display {
		display: flex;
		align-items: center;
		gap: 4px;
	}

	.total-costs-display.layout-condensed {
		gap: 3px;
	}

	.total-costs {
		font-size: 14px;
		font-weight: 700;
		line-height: 1.2;
		white-space: nowrap;
	}

	:global(.total-costs-info-btn) {
		opacity: 0.7;
		transition: opacity 0.2s ease;
		flex-shrink: 0;
	}

	:global(.total-costs-info-btn:hover) {
		opacity: 1;
	}

	.total-costs-display.variant-light :global(.total-costs-info-btn) {
		color: rgba(255, 255, 255, 0.9);
	}

	.total-costs-display.variant-dark :global(.total-costs-info-btn) {
		color: var(--color-text-secondary, #666);
	}

	.total-costs-display.variant-light .total-costs {
		color: #ffffff;
	}

	.total-costs-display.variant-dark .total-costs {
		color: var(--color-text-primary, #000);
	}

	.total-costs-display.layout-condensed .total-costs {
		font-size: 12px !important;
		line-height: 1.1 !important;
	}

	.total-costs-display.layout-condensed :global(.total-costs-info-btn) {
		transform: scale(0.75) !important;
	}
</style>
